export const USER_STAFF_EDIT_FUNCTIONAL_ROLE_MODAL_QA_NAME =
  'EditFunctionalRole'

export const USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME = 'functional_role'
